import {
 Component,
 Output,
 EventEmitter,
 OnInit,
 effect,
 WritableSignal,
 ChangeDetectorRef,
 Inject,
 DestroyRef,
 inject,
} from '@angular/core';
import { LoginRequest } from '@core/models/DTOs/authentication.dto';
import { AuthService } from '@core/services/authentication/auth.service';
import { NotificationService } from '@shared/components/notification/notification.service';
import { LoginRegisterWrapperComponent } from '../login-register-wrapper.component';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { GetUserProfileResponse } from '@core/models/DTOs/userProfile.dto';
import { UserProfileRepository } from '@core/services/repositories/userProfile.repository';
import { BehaviorSubject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
// import * as webengage from '/js/webengage-min-v-6.0.js';
@Component({
 selector: 'iho-login-user',
 templateUrl: './login-user.component.html',
 styleUrls: ['./login-user.component.scss'],
})
export class LoginUserComponent implements OnInit {
 showPass: boolean = false;
 errValidEmailPhone: boolean = false;
 errValidPassUser: boolean = false;
 passUser: string = '';
 isSend: boolean = true;
 @Output() status = new EventEmitter();
 isLoading$ = new BehaviorSubject(false);
 emailMobile: string = '';
 destroyRef = inject(DestroyRef);

 msgLogin: string = '';
 userData!: WritableSignal<GetUserProfileResponse>;

 constructor(
  public AuthService: AuthService,
  private router: Router,
  public UserProfileSrvc: UserProfileRepository,
  private route: ActivatedRoute,
  public dialogRef: MatDialogRef<LoginRegisterWrapperComponent>,
  public authSrvc: AuthService,
  public changeDetection: ChangeDetectorRef,
  public notif: NotificationService
 ) {
  effect(() => {
   this.userData = this.authSrvc.getUserData();
   if (this.userData()) {
    this.endLogin();
   }
  });
 }
 endLogin() {
  this.dialogRef.close();
  this.notif.success('ورود کاربر', '   با موفقیت انجام شد');
  this.router.navigate([], { queryParams: null, relativeTo: this.route });
  this.changeDetection.detectChanges();
 }
 ngOnInit(): void {}

 validatePhoneEmail() {
  let pattern =
   /(^(0|\u06F0)(9|\u06F9)(\d|[\u06F0-\u06F9]){9}$)|(^[\w\-]+(?:\.[\w\-]+)*@(?:[\w\-]+\.)+[a-zA-Z]{2,7}$)/;
  if (this.emailMobile.length) {
   if (pattern.test(this.emailMobile)) {
    this.errValidEmailPhone = false;
    this.isSend = true;
   } else {
    this.isSend = false;
    this.errValidEmailPhone = true;
    return;
   }

   if (this.passUser.trim() == '') {
    this.errValidPassUser = true;
    this.isSend = false;
    return;
   } else {
    this.errValidPassUser = false;
    this.isSend = true;
   }
  } else {
   this.isSend = false;
   this.errValidEmailPhone = true;
   return;
  }
 }

 emitStep(type: string) {
  this.status.emit(type);
 }

 submitForm() {
  this.validatePhoneEmail();
  if (this.isSend) {
   let modelLogin: LoginRequest = {
    UserName: this.emailMobile,
    Password: this.passUser,
    Token: '',
   };

   this.isLoading$.next(true);
   this.AuthService.loginUser(modelLogin)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((res: any) => {
     if (res) {
      this.isLoading$.next(false);

      if (res.result == true) {
       localStorage.setItem('AccessToken', res.jwtToken);
       document.cookie = `ihoLoggedIn=1; path=/; max-age=${60 * 60 * 24 * 30}`;
       this.authSrvc.userProfile();
      } else {
       this.msgLogin = res.message;

       this.isLoading$.next(false);
      }
     }
    });
  }
 }
}
